import React from 'react'
import { FormComponent } from '../../../components/form/DynamicForm'
import { Form, Validators } from '../../../components/form/DynamicFormTs'
import { withRouter } from "react-router-dom";
import Http from '../../../Http';

class TransportistaRuta extends FormComponent {

  componentDidMount() {
    this.FormConfig(
      { defaultUrl: 'transportista-ruta/one', saveUrl: 'transportista-ruta/save', backUrl: '/Catalogo/TransportistasRutas' },
      new Form([
        Form.Field('select', 'id_transportista', 'Transportista', '', [Validators.required], 4),
        Form.Field('select', 'id_circuito', 'Circuito', '', [Validators.required], 4),
        Form.Field('text', 'costo', 'Costo', '', [Validators.required], 4),
      ], ['Guardar'], 'Ruta transportista'), this.formData
    )
    if (this.props.match.params.id)
      this.LoadPreds()
  }

  formData = async (form) => {
    try {
      const Res = await Http.get('transportista-ruta/form');
      console.log(Res);
      if (!Res.error) {
        let newForm = Form.FieldOptions(form, 'id_transportista', Res.data.transportistas, 'id', 'transportista_nombre');
        newForm = Form.FieldOptions(form, 'id_circuito', Res.data.circuitos, 'id', 'circuito');
        return newForm;
      }
    } catch (error) {

    }
  }


  render() {
    return (
      <div>
        <this.FormRender />
      </div>
    )
  }
}

export default withRouter(TransportistaRuta)
